import { render } from "./ActiveTripCard.vue?vue&type=template&id=0a0bf236&scoped=true"
import script from "./ActiveTripCard.vue?vue&type=script&lang=js"
export * from "./ActiveTripCard.vue?vue&type=script&lang=js"

import "./ActiveTripCard.vue?vue&type=style&index=0&id=0a0bf236&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0bf236"]])

export default __exports__